<script setup>
import { ref, inject, onBeforeUnmount, watch, computed } from 'vue';
import { db } from '../firestore';
import { collection, getDocs, onSnapshot, orderBy, query, where, deleteField, updateDoc, doc as fireDoc } from 'firebase/firestore';
import Icon from '../Icon.vue';
import Dropdown from '../components/Dropdown.vue';
import { buildLink, constructHash, navigate, openInNewTab } from '../actions/documentActions';
import ScrollIntoView from '../chat/ScrollIntoView.vue';
import Tippy from '../components/Tippy.vue';

const userInfo = inject('userInfo')
const activeDoc = inject('document')
const confirmationTask = inject('confirmationTask')
const {deleteDocument} = inject('appActions')

function deleteConfirming({id, title}) {
  confirmationTask.value = {
    text: `This action will permanently delete '${title}' document. Proceed?`,
    onOK: () => {
      const moveAway = id === activeDoc.value.id
      deleteDocument(id)
      if (moveAway) {
        window.location.hash = ''
      }
    }
  }
}

const q = query(
  collection(db, 'docs'),
  where('owner', "==", userInfo.uid),
  orderBy("modified", "desc")
);
  
const querySnapshot = await getDocs(q);
const documents = ref([])

const unsubscribe = onSnapshot(q, (snapshot) => {
  console.log("documents changed")
  documents.value = snapshot.docs.map(doc => {
    const data = doc.data()
    return {
      id: doc.id,
      title: data.title,
      modified: data.modified,
      starred: data.starred
    }
  });
});

const groupedDocuments = computed(() => {
  const groupByTime = (docs) => {
    const now = Date.now();
    
    const groups = {
      starred: [],
      today: [],
      yesterday: [],
      lastWeek: [],
      lastMonth: [],
      older: []
    };
    docs.forEach(doc => {
      if (doc.starred) {
        groups.starred.push(doc)
        return
      }
      const diff = now - doc.modified;
      const daysAgo = diff / (1000 * 60 * 60 * 24); // Convert milliseconds to days
      
      if (daysAgo < 1) {
        groups.today.push(doc);
      } else if (daysAgo < 2) {
        groups.yesterday.push(doc);
      } else if (daysAgo < 7) {
        groups.lastWeek.push(doc);
      } else if (daysAgo < 30) {
        groups.lastMonth.push(doc);
      } else {        
        groups.older.push(doc);
      }
    });
    Object.keys(groups).forEach(key => {
      if (groups[key].length === 0) {
        delete groups[key]
      }
    }) 
    return groups;
  };

  return groupByTime(documents.value)
})

function hidePopover(e) {
  // const dropdown = e.target.closest('.dropdown')
  // dropdown.hidePopover();
}

onBeforeUnmount(() => {
  unsubscribe()
})

const LABELS = {
  starred: '⭐ Starred',
  today: '🗓️ Today',
  yesterday: '🗓️ Yesterday',
  lastWeek: '🗓️ Last Week',
  lastMonth: '🗓️ Last Month',
  older: '🗓️ Older',
}

async function updateStar(id, value) {
  const ref = fireDoc(db, 'docs', id)
  await updateDoc(ref, { starred: value ? true : deleteField() })
}

const menuFor = ref(null)
</script>

<template>  
  <ul class="documents-list bg-base-200">
    <template v-for="group in Object.keys(groupedDocuments)">
      <li>
        <h2 class="item-header underline">{{ LABELS[group] }}</h2>
      </li>
      <li v-for="doc in groupedDocuments[group]" >
        <Tippy :content="doc.title" placement="right" :class="['flex selectable item-navigable', (doc.id === activeDoc.id || doc.id === menuFor) && 'selected']" > 
          <a class="overflow-x-hidden" :href="buildLink({docId: doc.id})">
            <ScrollIntoView v-if="doc.id === activeDoc.id" position="center" style="display: inline"></ScrollIntoView>
            {{ doc.title || '<untitled>' }}
          </a>
          <Dropdown class="options-btn btn-xs btn-ghost btn-neutral py-[2px] px-[3px] ml-1" placement="right-start" @open="menuFor = doc.id"  @close="menuFor = null">        
            <template #button>
              <Icon :size="16"  name="heroicons--ellipsis-horizontal-16-solid"/>          
            </template>    
            <template #content>
              <ul class="flex flex-col gap-1  ">
                <li class="selectable item" @click="e => {hidePopover(e); openInNewTab(doc.id)}">open in new tab</li>
                <li v-if="doc.starred" class="selectable item" @click="e => {hidePopover(e); updateStar(doc.id, false)}">unstar</li>
                <li v-else class="selectable item" @click="e => {hidePopover(e); updateStar(doc.id, true)}">star</li>
                <li class="selectable item text-error" @click="e => {hidePopover(e); deleteConfirming(doc)}">delete</li>
              </ul>
            </template>    
          </Dropdown>      

        </Tippy>
      </li>
    </template>  
  </ul>
</template>

<style lang="less">

.documents-list {
  gap: 3px;
  display: flex;
  overflow-y: auto;

  flex-direction: column;
  
  // background-color: #f0eef0;
  
  padding: 10px;

  // h2 {
  //   color: var(--color-text-supressed);
  //   padding-left: 5px;
  // }
  @media (hover: hover) {
    .options-btn {
      visibility: hidden;
    }
    .options-btn:hover {
      // background-color: var(--color-base-200);
    }
    li:hover .options-btn {
      visibility: visible;
    }
  }

}





</style>
